import { useEffect, useRef, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ACCESS_TOKEN, REFRESH_TOKEN } from "../constants";

function removeUserScopedData() {
  const token = localStorage.getItem(ACCESS_TOKEN);
  if (!token) return;
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    if (payload && payload.username) {
      const key = `plantillasSeleccionadas_${payload.username}`;
      localStorage.removeItem(key);
    }
  } catch (_) {
    // ignore decoding errors
  }
}

export default function UserMenu({ usernameProp }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [username, setUsername] = useState("");
  const ref = useRef(null);

  useEffect(() => {
    if (usernameProp) setUsername(usernameProp);
    else {
      const stored = localStorage.getItem("username");
      if (stored) setUsername(stored);
      else {
        const token = localStorage.getItem(ACCESS_TOKEN);
        if (token) {
          try {
            const payload = JSON.parse(atob(token.split(".")[1]));
            const u = payload?.username || payload?.user || payload?.user_id || payload?.sub;
            if (u) setUsername(String(u));
          } catch {}
        }
      }
    }
  }, [usernameProp]);

  useEffect(() => {
    const onDocClick = (e) => {
      if (!ref.current) return;
      if (!ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("click", onDocClick);
    return () => document.removeEventListener("click", onDocClick);
  }, []);

  const handleLogout = () => {
    removeUserScopedData();
    localStorage.removeItem(ACCESS_TOKEN);
    localStorage.removeItem(REFRESH_TOKEN);
    localStorage.removeItem("username");
    navigate("/login");
  };

  const label = username ? username : "Cuenta";

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen((v) => !v)}
        className="px-4 py-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-lg shadow-sm text-gray-800 dark:text-gray-100 flex items-center gap-2 hover:shadow transition"
      >
        <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-blue-600 text-white text-sm font-semibold">
          {label.slice(0, 2).toUpperCase()}
        </span>
        <span className="font-medium max-w-[140px] truncate">{label}</span>
        <svg width="16" height="16" viewBox="0 0 20 20" fill="currentColor" className="opacity-70">
          <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z" clipRule="evenodd" />
        </svg>
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-56 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl shadow-xl z-20">
          <div className="py-1">
            <Link
              to="/configuracion"
              className="flex items-center gap-3 px-4 py-2 text-sm text-gray-800 dark:text-gray-100 hover:bg-gray-100 dark:hover:bg-gray-700"
              onClick={() => setOpen(false)}
            >
              <span className="inline-block w-2.5 h-2.5 rounded-full bg-gray-500"></span>
              Configuración
            </Link>
            <button
              onClick={handleLogout}
              className="w-full text-left flex items-center gap-3 px-4 py-2 text-sm text-gray-800 dark:text-gray-100 hover:bg-gray-100 dark:hover:bg-gray-700"
            >
              <span className="inline-block rotate-180">↪</span>
              Cerrar sesión
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
